import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://aclpkcwetodpuzamderk.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFjbHBrY3dldG9kcHV6YW1kZXJrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzU3NDYwMjksImV4cCI6MjA5MTMyMjAyOX0.AnT-PMraDOIWUPtlEvl57wrwlxOAws8JgPm-pp55Ye8';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
